export const ContentType = Object.freeze({
  SAVED_CONTENT: 'savedContent',
  SCHEDULED_CONTENT: 'scheduledContent'
})
